export default __webpack_public_path__ + "static/media/wishlist.587d5d52.png";